<template>
    <div class="benefit-filter-box container">
        <div class="benefit-filter-group">
            <span class="benefit-filter-group-type">Ver por segmento</span>
            <div class="benefit-filter-item-box">
                <button class="benefit-filter-item" @click="setFilter('segment', 'Lulo')" :class="{ active: selectedSegment === 'Lulo' }">Lulo</button>
                <button class="benefit-filter-item" @click="setFilter('segment', 'Lulo Pro')" :class="{ active: selectedSegment === 'Lulo Pro' }">Lulo Pro</button>
            </div>
        </div>
        <div class="benefit-filter-group">
            <span class="benefit-filter-group-type">Ver por medio de pago</span>
            <div class="benefit-filter-item-box">
                <button class="benefit-filter-item" @click="setFilter('card_type', 0)" :class="{ active: selectedCardType === 0 }">Tarjeta de crédito</button>
                <button class="benefit-filter-item" @click="setFilter('card_type', 1)" :class="{ active: selectedCardType === 1 }">Tarjeta débito</button>
            </div>
        </div>
        <div class="benefit-filter-group">
            <span class="benefit-filter-group-type">Ver por día</span>
            <div class="benefit-filter-item-box">
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 0)" :class="{ active: selectedDay === 0 }">L</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 1)" :class="{ active: selectedDay === 1 }">M</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 2)" :class="{ active: selectedDay === 2 }">W</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 3)" :class="{ active: selectedDay === 3 }">J</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 4)" :class="{ active: selectedDay === 4 }">V</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 5)" :class="{ active: selectedDay === 5 }">S</button>
                <button class="benefit-filter-item" @click="setFilter('day_of_week', 6)" :class="{ active: selectedDay === 6 }">D</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'benefit-filters',
    data() {
        return {
            selectedSegment: null,
            selectedCardType: null,
            selectedDay: null
        }
    },
    methods: {
        setFilter(group, value) {
            if (group === 'segment') {
                this.selectedSegment = this.selectedSegment === value ? null : value;
            } else if (group === 'card_type') {
                this.selectedCardType = this.selectedCardType === value ? null : value;
            } else if (group === 'day_of_week') {
                this.selectedDay = this.selectedDay === value ? null : value;
            }

            this.$emit('update-filters', {
                segment: this.selectedSegment,
                card_type: this.selectedCardType,
                day_of_week: this.selectedDay
            });
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../../styles/vars.less";

.benefit-filter-box {
    position: relative;
    display: flex;
    z-index: 1;
    gap: 32px;
    padding-bottom: 20px;
    margin: 0 auto 40px;
}

.benefit-filter-group {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: 1fr 1fr;
    align-items: start;
}

.benefit-filter-group-type {
    font-family: @bold;
}

.benefit-filter-item-box {
    display: flex;
    gap: 12px;
}

.benefit-filter-item {
    background: @white;
    padding: 0 18px;
    margin: auto;
    width: max-content;
    text-wrap: nowrap;
    height: 42px;
    cursor: pointer;
    transition: color 0.3s @custom-ease-1,
        background-color 0.3s @custom-ease-1,
        order 1s @custom-ease-2,
        margin-left 1s @custom-ease-2;

    &:before,
    &::after {
        content: none;
    }
}

.benefit-filter-item {

    &:hover {
        color: @blue-light;
    }
    @media (hover: hover) {
        &:hover , &:active{
            color: @white;
            background: @blue-light;
        }
    }

    &.active {
        color: @white;
        background: @blue-light;
    }
}

@media screen and (max-width: 1248px) {
    .benefit-filter-box {
        overflow-y: scroll;
        padding: 0 16px 20px;
    }
}
@media screen and (max-width: @tablet) {
    .benefit-filter-box {
        margin: 0 0 20px;
        max-width: calc(100% - 16px);
    }
}
</style>